module.exports = __webpack_public_path__ + "static/media/gator-protect-br.9053e230.png";